/**
 * Handles error extraction from error object
 * @param {Object} error Error object from API
 * @returns {String} Error string
 */
export const getError = (error) => {
  const { code } = error;
  // User not found error
  if (code === 'auth/user-not-found')
    return 'User is not signed up with this email';
  // User provided wrong password error
  if (code === 'auth/wrong-password')
    return 'Invalid user credentials provided';
  // Popup blocked
  if (code === 'auth/popup-blocked')
    return 'Login popup blocked - allow popups or click button again';
  // User closed popup
  if (code === 'auth/popup-closed-by-user')
    return 'Login popup closed - please click button again';
  // Unknown error
  return 'An error has occurred';
};
